module.exports = __webpack_public_path__ + "img/whychose3.20850d31.svg";